export const TOGGLE_LOADING = 'admin/user/permissions/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'admin/user/permissions/TOGGLE_SUCCESS'
export const GET_PERMISSIONS = 'admin/user/permissions/GET_PERMISSIONS'
export const SET_PERMISSIONS = 'admin/user/permissions/SET_PERMISSIONS'
export const SAVE_PERMISSIONS = 'admin/user/permissions/SAVE_PERMISSIONS'
export const ROLES_MERGE = 'admin/user/permissions/ROLES_MERGE'
